import React, { Component } from 'react';
import { TweenMax, TimelineMax, CSSPlugin, Expo, Draggable } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';


import '../styles/components/gallery.scss';

import Poster from './Poster';
import Video from './Video';

import raw from '../assets/raw.jpg';
import rig from '../assets/rig.jpg';
import sky from '../assets/sky.jpg';
import fallout from '../assets/fallout.jpg';
import doom from '../assets/doom.jpg';
import grab from '../assets/grab.svg';


const VIDEOS = {
  raw: 'https://www.youtube.com/watch?time_continue=1&v=IYLC812nDcI',
  rig:'https://vimeo.com/199788929',
  sky: 'https://vimeo.com/244658770',
  fallout: 'https://www.youtube.com/watch?v=4NkHQs7ann4',
  doom: 'https://vimeo.com/259232410'
}



export default class Gallery extends Component {

    constructor(props) {
      super(props);
      this.draggableGallery = null;
      this.posters = [];
      this.gamesPoster = null;
    }

    state = {
      open: false,
      play: false,
      src: ''
    }

    toggleVideoOn = newVideo => e => {
      this.setState({
        open: !this.state.open,
        play: !this.state.play,
        src: newVideo
      })
    }

    toggleVideoOff = () => {
      this.setState({
        open: !this.state.open,
        play: !this.state.play
      })
    }

    componentDidMount() {

      const imageGalleryWidth = this.draggableGallery.offsetWidth;
      const gamesPosterWidth = this.gamesPoster.offsetWidth;
      const minX = gamesPosterWidth-imageGalleryWidth;

      Draggable.create(this.draggableGallery, {
        bounds: { minX: minX, maxX: 0 },
        edgeResistance: 1,
        type: 'x'
      })
    }

    render() {

        return (
          <div className="gallery">
            <span className="small-title">Explore new realities with the vive&trade; pro</span>
            <span className="big-title">VIVE&trade; PRO Draws Innovative Games</span>
            <Video
              openState={ this.state.open }
              closeState={ this.toggleVideoOff }
              playState={ this.state.play }
              videoUrl= { this.state.src }
            />
            <div className="games-poster" ref={div => this.gamesPoster = div}>
                <div className="draggable-gallery" ref={div => this.draggableGallery = div}>
                  <Poster
                    myRef={(poster) => { this.posters.push(poster) }}
                    posterImage={ doom }
                    posterName="Doom"
                    posterInfo="Get the new Fallout 4 together with the VIVE Pro."
                    showVideo={this.toggleVideoOn(VIDEOS.doom)}
                  />
                  <Poster
                    myRef={(poster) => { this.posters.push(poster) }}
                    posterImage={ raw }
                    posterName="Raw-Data"
                    posterInfo="Immerse yourself within the surreal world of Eden Corp."
                    showVideo={this.toggleVideoOn(VIDEOS.raw)}
                  />
                  <Poster
                    myRef={(poster) => { this.posters.push(poster) }}
                    posterImage={ rig }
                    posterName="RIGS Mechanized Com..."
                    posterInfo="Only On VIVE Pro"
                    showVideo={this.toggleVideoOn(VIDEOS.rig)}
                  />
                  <Poster
                    myRef={(poster) => { this.posters.push(poster) }}
                    posterImage={ sky }
                    posterName="Skyrim"
                    posterInfo="Dragons have returned to Tamriel, and this time..."
                    showVideo={this.toggleVideoOn(VIDEOS.sky)}
                  />
                  <Poster
                    myRef={(poster) => { this.posters.push(poster) }}
                    posterImage={ fallout }
                    posterName="Fallout 4"
                    posterInfo="Get the new Fallout 4 together with the VIVE Pro."
                    showVideo={this.toggleVideoOn(VIDEOS.fallout)}
                  />
                </div>
            </div>
            <span className="summary">Play some of the most highly anticipated titles coming soon to VIVE Pro including an all-new <br/>STAR WARS Battlefront gaming experience and games like Doom</span>
          </div>
        );
    }
}
